// Public support page for the Eizel service. Served at /support with no
// auth — referenced by the App Store listing (Support URL is a required
// submission field). Keep the contact address in sync with PrivacyPage.
export default function SupportPage() {
  return (
    <>
      <header className="shared-article-header">
        <a href="https://eizel.co" className="shared-article-logo">
          <img src="/favicon.svg" alt="Eizel" width={22} height={22} />
          <span>Eizel</span>
        </a>
      </header>
      <main className="page">
        <h1 className="article-detail-title">Support</h1>
        <hr className="article-detail-divider" />
        <div className="article-content article-content--plaintext">
          <p>
            Need help with Eizel? Email <a href="mailto:support@eizel.co">support@eizel.co</a> and
            we&rsquo;ll get back to you. The quick answers below cover the most common questions.
          </p>

          <h2>Saving articles</h2>
          <ul>
            <li>
              <strong>From any app:</strong> tap Share, then choose <strong>Eizel</strong> to save
              the current page to your library.
            </li>
            <li>
              <strong>By email:</strong> forward or send a link to <strong>save@eizel.co</strong>{' '}
              from an email address you&rsquo;ve verified, and it&rsquo;s added to your library.
            </li>
            <li>
              <strong>In the app:</strong> tap the <strong>+</strong> button and paste a link.
            </li>
          </ul>

          <h2>Verifying your email</h2>
          <p>
            New accounts and newly added addresses need to be verified before you can use them.
            Check your inbox (and spam folder) for the verification email. You can re-send it from{' '}
            <strong>Settings</strong> next to the pending address. You can register up to three
            email addresses.
          </p>

          <h2>Signing in</h2>
          <p>
            You can sign in with email and password, Google, or Sign in with Apple. If you use Sign
            in with Apple with &ldquo;Hide My Email,&rdquo; that creates a separate library tied to
            your private Apple relay address — to keep everything in one account, sign in the same
            way you first signed up, or choose &ldquo;Share My Email&rdquo; with Apple.
          </p>

          <h2>Offline reading (iOS)</h2>
          <p>
            The iOS app automatically downloads your saved articles so you can read them without a
            connection. Storage usage is shown in <strong>Settings</strong>.
          </p>

          <h2>Deleting your account</h2>
          <p>
            You can permanently delete your account and all saved content from the iOS app at{' '}
            <strong>Settings &rarr; Remove Account</strong>. This cannot be undone. See our{' '}
            <a href="/privacy">Privacy Policy</a> for details on the data we handle.
          </p>

          <h2>Still need help?</h2>
          <p>
            Email <a href="mailto:support@eizel.co">support@eizel.co</a> and include your account
            email and a short description of the issue.
          </p>
        </div>
        <div className="shared-article-footer">
          <a href="https://eizel.co">eizel.co</a>
        </div>
      </main>
    </>
  )
}
